import { Box } from '@mui/joy';
import { KeyboardEvent } from 'react';
import { UseFormHandleSubmit } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IUpsertLineFormData } from 'jobs/components/JobDetails/tabs/MaterialList/PartList/UpsertLine';
import { IUom } from 'parts/types';

interface IProps {
  onBlurQuantity: () => void;
  onKeyDownQuantity: (
    event: KeyboardEvent<HTMLInputElement>,
    handleSubmit: UseFormHandleSubmit<IUpsertLineFormData>
  ) => void;
  onChangeUom: () => void;
  uomOptions: IUom[];
  disabledQuantity: boolean;
  isValidating: boolean;
  emptyPartValues: boolean;
}

export const QuantitySection = ({
  onBlurQuantity,
  onKeyDownQuantity,
  onChangeUom,
  uomOptions,
  disabledQuantity,
  isValidating,
  emptyPartValues,
}: IProps) => {
  const { t } = useTranslation();

  const { control, errors, handleSubmit } = useFormContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 1,
      }}
    >
      <FormField
        name="quantity"
        type={InputType.NUMBER_INPUT}
        inputProps={{
          control: control,
          error: errors.quantity,
          label: t('labelQuantity'),
          placeholder: t('placeholderQuantity'),
          onBlur: onBlurQuantity,
          onKeyDown: (event: KeyboardEvent<HTMLInputElement>) =>
            onKeyDownQuantity(event, handleSubmit),
          slotProps: {
            input: {
              min: 0,
            },
          },
          disabled: disabledQuantity || isValidating || emptyPartValues,
          required: true,
        }}
      />

      <FormField
        name="uom"
        type={InputType.SELECT}
        inputProps={{
          control: control,
          error: errors.uom,
          label: t('labelUom'),
          placeholder: t('placeholderUpsertLineUom'),
          getLabel: (option: IUom) => option?.name,
          getValue: (option: IUom) => option?.name,
          onChange: onChangeUom,
          options: uomOptions,
          disabled: isValidating || emptyPartValues,
          required: true,
        }}
      />
    </Box>
  );
};
